import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const inviteList = async (params: object) => {
  return await GET({ url: Api.inviteList, params, showError: false })
}
export const invite = async (params: object) => {
  return await GET({ url: Api.invite, params, showError: false })
}
export const contact = async (params: object) => {
  return await GET({ url: Api.contact, params, showError: false })
}
export const confirmContact = async (params: object) => {
  return await GET({ url: Api.confirmContact, params, showError: false })
}
export const headData = async (params: object) => {
  return await GET({ url: Api.headData, params, showError: false })
}
export const queryRecommendWords = async (params: object) => {
  return await GET({ url: Api.queryRecommendWords, params, showError: false })
}
